import { DT } from '../theme/designTokens';
import { useTranslation } from '../i18n/react';

/**
 * Generic Coming Soon placeholder for registered-but-unbuilt routes
 * (currently only /shop). Extracted from App.tsx unchanged so it can be
 * rendered in tests without pulling in the full screen graph. Honest by
 * design: a title and a Coming soon line, no functionality implied.
 */
export function ComingSoon({ titleKey }: { titleKey: 'screen.shop' }) {
  const { t } = useTranslation('common');
  return (
    <div
      style={{
        padding:        '80px 24px',
        display:        'flex',
        justifyContent: 'center',
        alignItems:     'center',
        minHeight:      '60vh',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 40, fontWeight: 400, color: DT.color.textPrimary, fontFamily: DT.font.heading, marginBottom: 10, letterSpacing: '0.05em' }}>
          {t(titleKey)}
        </div>
        <div style={{ fontSize: 13, color: DT.color.textMuted, fontFamily: DT.font.sans, letterSpacing: '0.12em', textTransform: 'uppercase' as const }}>
          {t('status.comingSoon')}
        </div>
      </div>
    </div>
  );
}
